import Drawable from '../entities/Drawable.js';
import PrimaryPokemonBox from './PrimaryPokemonBox.js';
import SecondaryPokemonBox from './SecondaryPokemonBox.js';
import OptionsBox from './OptionsBox.js';
import PixelText from './PixelText.js';
import Sprite from './Sprite.js';

import { imageStore, spriteStore } from '../images.js';
import { getOSM } from '../OverworldAnimation.js';

import { BATTLE } from '../constants.js';

export default class PokemonMenu extends Drawable {
    constructor({ GUI, currentOption, partyPokemon, position = { x: 0, y: 0 }, visible = false }) {
        super();
        this.GUI = GUI;
        this.partyPokemon = partyPokemon;
        this.position = position;
        this.visible = visible;
        this.sprites = {};
        this.sprites.background = spriteStore.store.pokemonMenuBackground;
        this.sprites.primaryPokemonBox = new PrimaryPokemonBox({
            pokemon: this.partyPokemon[0],
            position: { x: this.position.x + 2, y: this.position.y + 18 },
            visible: true,
            pokemonMenu: this,
        });
        this.shouldShowMoveLearnability = false;

        this.sprites.secondaryPokemonBoxes = [null, null, null, null, null];
        for (let i = 0; i < 5; i++) {
            this.sprites.secondaryPokemonBoxes[i] = new SecondaryPokemonBox({
                pokemon: null,
                position: {
                    x: this.position.x + 88,
                    y: this.position.y + 9 + i * 24,
                },
                visible: false,
                pokemonMenu: this,
                order: i + 1,
            });
            if (i < this.partyPokemon.length - 1) {
                this.sprites.secondaryPokemonBoxes[i].pokemon = this.partyPokemon[i + 1];
                this.sprites.secondaryPokemonBoxes[i].visible = true;
            } else {
                this.sprites.secondaryPokemonBoxes[i].pokemon = null;
                this.sprites.secondaryPokemonBoxes[i].visible = false;
            }
        }

        this.helpText = new PixelText({
            text: 'Choose a Pokemon.',
            position: { x: this.position.x + 8, y: this.position.y + 148 - 7 },
            color: 'black',
        });
        this.currentOption = Math.floor(currentOption);

        this.sprites.cancelBox = new Sprite({
            position: { x: this.position.x + 184, y: this.position.y + 132 },
            image: imageStore.get('img/pokemon_menu_cancel_box.png'),
            moving: false,
            frames: { max: 2, val: 1 },
        });

        this.sprites.pokemonOptionsBox = new OptionsBox({
            position: { x: 160, y: 80 },
            visible: false,
            options: ['Summary', 'Switch', 'Item', 'Cancel'],
        });

        this.sprites.pokemonItemOptionsBox = new OptionsBox({
            position: { x: 176, y: 96 },
            visible: false,
            options: ['Give', 'Take', 'Cancel'],
        });

        this.sprites.moveOptionsBox = new OptionsBox({
            position: { x: 160, y: 80 },
            visible: false,
            options: ['--', '--', '--', '--'],
        });
    }

    getCurrentPokemonBySwitchIndex() {
        return this.partyPokemon[getOSM().context.pokemonSwitchIndex1];
    }

    getCurrentPokemon() {
        return this.partyPokemon[this.currentOption];
    }

    draw() {
        if (!this.visible) {
            return;
        }

        for (let i = 0; i < 5; i++) {
            if (i < this.partyPokemon.length - 1) {
                this.sprites.secondaryPokemonBoxes[i].pokemon = this.partyPokemon[i + 1];
                this.sprites.secondaryPokemonBoxes[i].visible = true;
            } else {
                this.sprites.secondaryPokemonBoxes[i].pokemon = null;
                this.sprites.secondaryPokemonBoxes[i].visible = false;
            }
        }

        this.sprites.background.visible = this.visible;
        this.sprites.primaryPokemonBox.visible = this.visible;
        this.sprites.secondaryPokemonBoxes.forEach((box) => {
            box.visible = this.visible;
        });
        this.sprites.background.draw();
        if (this.partyPokemon.length > 0) {
            this.sprites.primaryPokemonBox.pokemon = this.partyPokemon[0];
            this.sprites.primaryPokemonBox.draw();
        }
        this.helpText.draw();

        if (this.currentOption === this.partyPokemon.length) {
            this.sprites.cancelBox.frames.val = 0;
        } else {
            this.sprites.cancelBox.frames.val = 1;
        }

        this.sprites.secondaryPokemonBoxes.forEach((box) => {
            box.draw();
        });

        this.sprites.cancelBox.draw();
        switch (getOSM().currentState) {
            case BATTLE:
                this.sprites.pokemonOptionsBox.setOptions(['Switch', 'Summary', 'Cancel']);
                break;
            default:
                this.sprites.pokemonOptionsBox.setOptions([
                    'Summary',
                    'Switch',
                    'Item',
                    'Nickname',
                    'Cancel',
                ]);
        }
        this.sprites.pokemonOptionsBox.draw();
        this.sprites.pokemonItemOptionsBox.draw();
        this.sprites.moveOptionsBox.draw();
    }
}
